// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"e6d0a118","762":"2a15adab"}[chunkId] + ".chunk.css";
};